import { lazy } from "react";

/**
 * Wrapper around React.lazy that retries on ChunkLoadError.
 * Handles stale deploys where chunk hashes change and old URLs 404,
 * as well as transient network failures.
 *
 * Retry strategy: one retry after 1.5s, then one page reload.
 * Uses sessionStorage to prevent infinite reload loops.
 */
const lazyWithRetry = (importFn) =>
  lazy(() =>
    importFn().catch((error) => {
      if (
        error.name === "ChunkLoadError" ||
        error.message?.includes("Loading chunk")
      ) {
        return new Promise((resolve) => setTimeout(resolve, 1500))
          .then(() => importFn())
          .catch(() => {
            const reloadKey = "chunk_reload_" + window.location.pathname;
            const alreadyReloaded = sessionStorage.getItem(reloadKey);
            if (!alreadyReloaded) {
              sessionStorage.setItem(reloadKey, "1");
              window.location.reload();
              return new Promise(() => {});
            }
            // Already reloaded once — let error boundary handle it
            sessionStorage.removeItem(reloadKey);
            throw new Error("Failed to load page after retry and reload. Please try again later.");
          });
      }
      throw error;
    })
  );

export default lazyWithRetry;
